var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"bg-white rounded-xl px-4"},[_c('BlogsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }